import { Maximize, Minimize } from "lucide-react";
import { useFullscreen } from "../hooks/useFullscreen";

interface FullscreenButtonProps {
  className?: string;
}

export function FullscreenButton({ className = "hud__tool" }: FullscreenButtonProps) {
  const { active, supported, toggle } = useFullscreen();
  if (!supported) return null;
  return (
    <button
      className={className}
      type="button"
      onClick={() => { void toggle(); }}
      title={active ? "退出全屏" : "进入全屏"}
      aria-label={active ? "退出全屏" : "进入全屏"}
      aria-pressed={active}
    >
      {active ? <Minimize size={19} /> : <Maximize size={19} />}
      <span>{active ? "退出全屏" : "全屏"}</span>
    </button>
  );
}
